module.exports = __webpack_public_path__ + "img/中繼站2_計算成績.8c390489.png";